import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

import * as reducers from './modules';

export default combineReducers({
  ...reducers,
  router: routerReducer
});



// WEBPACK FOOTER //
// ./src/state/rootReducer.js